import { apiHelper } from "./api_helper";

export const tinhHuyenXaApi = {
    SelectTinh: () => apiHelper.get('tinh'),
    SelectHuyenByTinh: (id) => apiHelper.get(`tinh/${id}/huyen`),
    SelectXaByHuyen: (id) => apiHelper.get(`huyen/${id}/xa`)
}